import useRoleList from "./useRoleList";
import useUpdateDefaultRole from './useUpdateDefaultRole'
import useRemoveDefaultRole from './useRemoveDefaultRole'
import useSelectRole from './useSelectRole'

export default { useRoleList, useSelectRole, useRemoveDefaultRole, useUpdateDefaultRole }